import TreeV from './treeV.vue';

export default TreeV;



// WEBPACK FOOTER //
// ./src/FcComponents/treeV/index.js